module.exports = __webpack_public_path__ + "static/media/verification_pending.efa1d2f4.svg";